document.addEventListener('DOMContentLoaded', function() {
    // Esperar a que todos los componentes personalizados estén definidos
    setTimeout(function() {
      // Selecciona todos los componentes header-menu que contengan mega-menu
      const headerMenus = document.querySelectorAll('header-menu');
      
      if (window.matchMedia('(min-width: 750px)').matches) {
        headerMenus.forEach(menu => {
          const details = menu.querySelector('details.mega-menu');
          const summary = details ? details.querySelector('summary') : null;
          const content = details ? details.querySelector('.mega-menu__content') : null;
          
          if (details && summary && content) {
            // Prevenir el comportamiento de clic
            summary.addEventListener('click', function(e) {
              if (window.matchMedia('(min-width: 750px)').matches) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            });
            
            // Usar hover para abrir
            details.addEventListener('mouseenter', function() {
              this.setAttribute('open', '');
              summary.setAttribute('aria-expanded', 'true');
            });
            
            // Cerrar solo cuando el mouse sale de todo el menú (details Y content)
            // Creamos un temporizador para evitar cierres accidentales
            let timeout;
            
            // Si el mouse sale de details pero entra en content, cancelamos el cierre
            content.addEventListener('mouseenter', function() {
              clearTimeout(timeout);
            });
            
            // Si el mouse sale de details, programamos un cierre con retraso
            details.addEventListener('mouseleave', function(e) {
              // Solo cerrar si el mouse realmente ha salido de details Y content
              if (!details.contains(e.relatedTarget) && !content.contains(e.relatedTarget)) {
                timeout = setTimeout(() => {
                  details.removeAttribute('open');
                  summary.setAttribute('aria-expanded', 'false');
                }, 100); // pequeño retraso para permitir movimiento entre elementos
              }
            });
            
            // Si el mouse sale del content, cerramos el menú (con un pequeño retraso)
            content.addEventListener('mouseleave', function(e) {
              // Solo cerrar si el mouse realmente ha salido de details Y content
              if (!details.contains(e.relatedTarget) && !content.contains(e.relatedTarget)) {
                timeout = setTimeout(() => {
                  details.removeAttribute('open');
                  summary.setAttribute('aria-expanded', 'false');
                }, 100);
              }
            });
          }
        });
      }
      
      // Manejar cambios de tamaño de ventana
      window.matchMedia('(min-width: 750px)').addEventListener('change', function(e) {
        if (!e.matches) {
          headerMenus.forEach(menu => {
            const details = menu.querySelector('details.mega-menu');
            const summary = details ? details.querySelector('summary') : null;
            if (details && summary) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    }, 100); // pequeño retraso para asegurar que los componentes estén cargados
  });